import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  IconButton,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  Alert,Snackbar,
  TextField, // ✅ Added search bar
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import AddPhoneNumber from "../Adding/addPhoneNumber/phoneNumber";
import "./displaynumber.css";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";

const PhoneNumberPage = ({ data = [] }) => {
  const initialData = Array.isArray(data) ? data : [];
  const [tableData, setTableData] = useState(initialData);
  const [filteredData, setFilteredData] = useState(initialData); // ✅ For search
  const [searchQuery, setSearchQuery] = useState(""); // ✅ Search state

  const [showAddForm, setShowAddForm] = useState(false);
  const [deletingIndex, setDeletingIndex] = useState(null);

  // ✅ For modal confirmatio
  const [confirmDeleteIndex, setConfirmDeleteIndex] = useState(null);
const [actionClicked, setActionClicked] = useState(null); 
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
const EncryptedInstanceId=localStorage.getItem("EncryptedId")
  useEffect(() => {
    if (Array.isArray(data)) {
      setTableData(data);
      setFilteredData(data); // ✅ Initialize filtered data
    }
  }, [data]);

  const handleAddSuccess = (newPhoneNumber) => {
    setTableData((prev) => [...prev, newPhoneNumber]);
    setFilteredData((prev) => [...prev, newPhoneNumber]);
    setShowAddForm(false);
  };

  const handlePhoneNumberAdded = (updatedData) => {
    const safeArray = Array.isArray(updatedData) ? updatedData : [];
    setTableData(safeArray);
    setFilteredData(safeArray);
    setShowAddForm(false);
  };
  const [snackbar, setSnackbar] = useState({
  open: false,
  message: "",
  severity: "error", // "success" | "error" | "warning" | "info"
});

  // const handleDelete = async (indexToDelete) => {
  //   setDeletingIndex(indexToDelete);
  //   const item = filteredData[indexToDelete];

  //   if (!item.PhoneNumber) {
  //     console.error("Missing phone number for deletion.");
  //     setDeletingIndex(null);
  //     return;
  //   }

  //   const payload = {
  //     ID:EncryptedInstanceId,
  //     awsAccount: customerAWSAccountId,
  //     InstanceAlias: instanceAlias,
  //     region,
  //     PhoneNumber: item.PhoneNumber.trim(),
  //   };

  //   try {
  //     const response = await axiosInstance.post(
  //       endpoints.phoneNumberRelease.phoneRelease,
  //       payload
  //     );

  //     const statusCode = response.data?.statusCode;
  //     if (statusCode === 200) {
  //       const updatedTable = tableData.filter(
  //         (phone) => phone.PhoneNumber !== item.PhoneNumber
  //       );
  //       setTableData(updatedTable);

  //       const updatedFiltered = filteredData.filter(
  //         (_, i) => i !== indexToDelete
  //       );
  //       setFilteredData(updatedFiltered);
  //     } else {
  //       console.error("API error:", response.data);
       
  //     }
  //   } catch (error) {
  //     console.error(
  //       "Error during delete:",
  //       error.response?.data || error.message
  //     );
      
  //   } finally {
  //     setDeletingIndex(null);
  //   }
  // };
  
const handleDelete = async (indexToDelete) => {
  setDeletingIndex(indexToDelete);
  const item = filteredData[indexToDelete];

  if (!item.PhoneNumber) {
    console.error("Missing phone number for deletion.");
    setDeletingIndex(null);
    return;
  }

  const payload = {
    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    InstanceAlias: instanceAlias,
    region,
    PhoneNumber: item.PhoneNumber.trim(),
  };

  try {
    const response = await axiosInstance.post(
      endpoints.phoneNumberRelease.phoneRelease,
      payload
    );

    const statusCode = response.data?.statusCode;
    const body = response.data?.body || "";

    if (statusCode === 200) {
      const updatedTable = tableData.filter(
        (phone) => phone.PhoneNumber !== item.PhoneNumber
      );
      setTableData(updatedTable);

      const updatedFiltered = filteredData.filter(
        (_, i) => i !== indexToDelete
      );
      setFilteredData(updatedFiltered);

      setSnackbar({
        open: true,
        message: "Phone number deleted successfully.",
        severity: "success",
      });
    } else if (
      statusCode === 500 &&
      body.includes("ResourceInUseException")
    ) {
      // ❌ cannot delete due to queue association
      setSnackbar({
        open: true,
        message:
          "This phone number cannot be deleted because it’s associated with a queue.",
        severity: "warning",
      });
    } else {
      console.error("API error:", response.data);
      setSnackbar({
        open: true,
        message: "Failed to delete phone number.",
        severity: "error",
      });
    }
  } catch (error) {
    console.error("Error during delete:", error.response?.data || error.message);
    setSnackbar({
      open: true,
      message: "An unexpected error occurred while deleting.",
      severity: "error",
    });
  } finally {
    setDeletingIndex(null);
  }
};
  // ✅ Handle search
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (!query) {
      setFilteredData(tableData);
      return;
    }

    const filtered = tableData.filter((item) => {
      return (
        (item.PhoneNumber || "").toLowerCase().includes(query) ||
        (item.PhoneType || "").toLowerCase().includes(query) ||
        (item.Country || "").toLowerCase().includes(query) ||
        (item.Description || "").toLowerCase().includes(query) ||
        (item.Contactflow || "").toLowerCase().includes(query) ||
        (Array.isArray(item.ActiveChannels)
          ? item.ActiveChannels.join(", ")
          : item.ActiveChannels || ""
        )
          .toLowerCase()
          .includes(query)
      );
    });

    setFilteredData(filtered);
  };

  if (showAddForm) {
    return (
      <AddPhoneNumber
        onClose={() => setShowAddForm(false)}
        onAddSuccess={handlePhoneNumberAdded}
        instanceAlias={instanceAlias}
        instanceId={instanceId}
        customerAWSAccountId={customerAWSAccountId}
        region={region}
      />
    );
  }

  return (
    <Box className="phone-number-container">
  <Typography variant="h6"   className="phone-number-title">
          Phone Number List 
        </Typography>
        <br></br>
      <Box
        className="phone-number-header"
        sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
      >
       

<TextField
  placeholder="Search..."
  value={searchQuery}
  className="search-textfield"
  onChange={handleSearchChange}  // live filtering

  sx={{ width: 300 }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <SearchIcon />
      </InputAdornment>
    ),
  }}
/>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setShowAddForm(true)}
        >
          Add Phone Number
        </Button>
      </Box>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table className="phone-number-table" sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: "#f3f3f3" }}>
            <TableRow>
              <TableCell>
                <strong>Phone Number</strong>
              </TableCell>
              <TableCell>
                <strong>Type</strong>
              </TableCell>
              <TableCell>
                <strong>Country</strong>
              </TableCell>
              <TableCell>
                <strong>Description</strong>
              </TableCell>
              <TableCell>
                <strong>Contact Flow</strong>
              </TableCell>
              <TableCell>
                <strong>Active Channels</strong>
              </TableCell>
              <TableCell>
                <strong>Actions</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.PhoneNumber || "-"}</TableCell>
                  <TableCell>{item.PhoneType || "-"}</TableCell>
                  <TableCell>{item.Country || "-"}</TableCell>
                  <TableCell>{item.Description || "-"}</TableCell>
                  <TableCell>{item.Contactflow || "-"}</TableCell>
                  <TableCell>
                    {Array.isArray(item.ActiveChannels)
                      ? item.ActiveChannels.join(", ")
                      : item.ActiveChannels || "-"}
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Release">
                      <span>
                        <IconButton
                          onClick={() => setConfirmDeleteIndex(index)} // ✅ Open modal
                          disabled={deletingIndex === index}
                          color="error"
                        >
                          {deletingIndex === index ? (
                            <CircularProgress size={18} />
                          ) : (
                            <DeleteIcon />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} className="no-data-row">
                  No matching phone numbers found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
  open={confirmDeleteIndex !== null}
  onClose={() => setConfirmDeleteIndex(null)}
>
  <DialogContent>
    Are you sure you want to delete{" "}
    <strong>
      {confirmDeleteIndex !== null
        ? filteredData[confirmDeleteIndex]?.PhoneNumber
        : ""}
    </strong>
    ?
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => {
        setActionClicked("no");
        setConfirmDeleteIndex(null);
      }}
      disabled={actionClicked === "yes" || actionClicked === "no"}
    >
      {actionClicked === "no" ? <CircularProgress size={18} /> : "No"}
    </Button>

    <Button
      color="error"
      variant="contained"
      onClick={async () => {
        setActionClicked("yes");
        if (confirmDeleteIndex !== null) {
          await handleDelete(confirmDeleteIndex);
        }
        setConfirmDeleteIndex(null);
        setActionClicked(null); // reset after closing
      }}
      disabled={actionClicked === "yes" || actionClicked === "no"}
    >
      {actionClicked === "yes" ? (
        <CircularProgress size={18} style={{ color: "white" }} />
      ) : (
        "Yes"
      )}
    </Button>
  </DialogActions>
</Dialog>

      <Snackbar
  open={snackbar.open}
  autoHideDuration={4000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
>
  <Alert
    onClose={() => setSnackbar({ ...snackbar, open: false })}
    severity={snackbar.severity}
    sx={{ width: "100%" }}
  >
    {snackbar.message}
  </Alert>
</Snackbar>
    </Box>
  );
};

export default PhoneNumberPage;
